// FETCH ALL PROGRAM_MAPPING
export const FETCH_PROGRAM_MAPPING_REQUEST = 'FETCH_PROGRAM_MAPPING_REQUEST';
export const FETCH_PROGRAM_MAPPING_SUCCESS = 'FETCH_PROGRAM_MAPPING_SUCCESS';
export const FETCH_PROGRAM_MAPPING_FAILURE = 'FETCH_PROGRAM_MAPPING_FAILURE';

// FETCH ALL PROGRAM_MAPPING
export const FETCH_TABLE_NAMES_REQUEST = 'FETCH_TABLE_NAMES_REQUEST';
export const FETCH_TABLE_NAMES_SUCCESS = 'FETCH_TABLE_NAMES_SUCCESS';
export const FETCH_TABLE_NAMES_FAILURE = 'FETCH_TABLE_NAMES_FAILURE';

// FETCH ALL CURRENCY
export const FETCH_CURRENCY_REQUEST = 'FETCH_CURRENCY_REQUEST';
export const FETCH_CURRENCY_SUCCESS = 'FETCH_CURRENCY_SUCCESS';
export const FETCH_CURRENCY_FAILURE = 'FETCH_CURRENCY_FAILURE';

// CREATE PROGRAM_MAPPING
export const CREATE_PROGRAM_MAPPING_REQUEST = 'CREATE_PROGRAM_MAPPING_REQUEST';
export const CREATE_PROGRAM_MAPPING_SUCCESS = 'CREATE_PROGRAM_MAPPING_SUCCESS';
export const CREATE_PROGRAM_MAPPING_FAILURE = 'CREATE_PROGRAM_MAPPING_FAILURE';

// UPDATE PROGRAM_MAPPING
export const UPDATE_PROGRAM_MAPPING_REQUEST = 'UPDATE_PROGRAM_MAPPING_REQUEST';
export const UPDATE_PROGRAM_MAPPING_SUCCESS = 'UPDATE_PROGRAM_MAPPING_SUCCESS';
export const UPDATE_PROGRAM_MAPPING_FAILURE = 'UPDATE_PROGRAM_MAPPING_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_PROGRAM_MAPPING_REQUEST = 'FETCH_SINGLE_PROGRAM_MAPPING_REQUEST';
export const FETCH_SINGLE_PROGRAM_MAPPING_SUCCESS = 'FETCH_SINGLE_PROGRAM_MAPPING_SUCCESS';
export const FETCH_SINGLE_PROGRAM_MAPPING_FAILURE = 'FETCH_SINGLE_PROGRAM_MAPPING_FAILURE';

// DELETE PROGRAM_MAPPING
export const DELETE_PROGRAM_MAPPING_REQUEST = 'DELETE_PROGRAM_MAPPING_REQUEST';
export const DELETE_PROGRAM_MAPPING_SUCCESS = 'DELETE_PROGRAM_MAPPING_SUCCESS';
export const DELETE_PROGRAM_MAPPING_FAILURE = 'DELETE_PROGRAM_MAPPING_FAILURE';

export const RESET_PROGRAM_MAPPING_INFO = 'RESET_PROGRAM_MAPPING_INFO';

export const CREATE_PROGRAM_MAPPING_FORM = 'CREATE_PROGRAM_MAPPING_FORM';

export const UPDATE_PROGRAM_MAPPING_FORM = 'UPDATE_PROGRAM_MAPPING_FORM';
